import type { MouseEventHandler } from "react";
import { useEffect } from "react";

import useHasHydrated from "@/lib/hooks/useHasHydrated";
import useWishlist from "@/lib/hooks/useWishlist";

type Props = React.PropsWithChildren<{
  id: string;
  setInWishlist: (arg0: boolean) => void;
}>;

const FavouritesButton = ({ id, setInWishlist, children }: Props) => {
  const { ids, toggle, includes } = useWishlist();
  const hydrated = useHasHydrated();

  useEffect(() => {
    if (includes(id) && hydrated) {
      setInWishlist(true);
      return;
    }
    setInWishlist(false);
    return;
  }, [ids, hydrated]);

  const handleClick =
    (toggle: () => void): MouseEventHandler<HTMLElement> =>
    (e) => {
      e.stopPropagation();
      e.preventDefault();
      toggle();
    };

  return (
    <div onClick={handleClick(toggle(id))} aria-label={"Button"}>
      {children}
    </div>
  );
};

export default FavouritesButton;
